import { render, staticRenderFns } from "./song.vue?vue&type=template&id=3c0d0809"
import script from "./song.vue?vue&type=script&lang=js"
export * from "./song.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports